export default __webpack_public_path__ + "static/media/pic15.d6f404b5.jpg";